// removed by extract-text-webpack-plugin
module.exports = {"germanVATInc":"_3BT-YhX"};


//////////////////
// WEBPACK FOOTER
// ./template/components/MiniBag/Footer/SubTotal/GermanVATIncluded/index.css
// module id = ./template/components/MiniBag/Footer/SubTotal/GermanVATIncluded/index.css
// module chunks = client.sitechrome